import React from "react";
import Slots from "./components/Slots";
import "./styles.css"; 

export default function App() {  

  return (
    <div className="app">
      <Slots />
    </div>
  );
}
